import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { API_BASE_CRM_URL } from "../../Config/Config";
import Pagination from "../../Config/Pagination";
import Base from "../../Config/Base";

import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useNavigate } from "react-router-dom";
import { Footer } from "../footer/footer";
import { Drawer, Select, Input, DatePicker, Button, message } from "antd";
import dayjs from "dayjs";
import axios from "axios";

import {
  DollarOutlined,
  CalendarOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import Swal from "sweetalert2";

const { TextArea } = Input;

const Credit = () => {
  const navigate = useNavigate();

  const userDetailsSession = JSON.parse(sessionStorage.getItem("userDetails"));
  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);

  const [loading, setLoading] = useState(false);
  const [creditsData, setCreditsData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_CRM_URL}creditnotes/GetCreditNotes`,
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();

      if (data.Status) {
        setCreditsData(data.Data);
      } else {
        console.error("Fetched data is not an array:", data);
        setCreditsData([]);
      }
    } catch (error) {
      console.error("Error fetching datasssss:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const filteredItems = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();

    const data = Array.isArray(creditsData) ? creditsData : [];

    // If no search text, return all records
    if (!term) {
      return data;
    }

    return data.filter((item) => {
      return (
        item.paymentsModeName?.toLowerCase().includes(term) ||
        item.transactionid?.toLowerCase().includes(term) ||
        item.company_name?.toLowerCase().includes(term)
      );
    });
  }, [creditsData, searchTerm]);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const [creditDrawer, setCreditDrawer] = useState(false);

  const [customers, setCustomers] = useState([]);

  const [creditData, setCreditData] = useState({
    clientid: null,
    total: "",
    date: dayjs(),
    clientnote: "",
  });

  const getCustomers = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_CRM_URL}customers/GetCustomers`,
      );

      console.log(response.data);

      setCustomers(response.data?.ResultData ?? []);
    } catch (error) {
      console.error(error);
      setCustomers([]);
    }
  };

  useEffect(() => {
    getCustomers();
  }, []);

  const handleAddCredit = async () => {
    try {
      const payload = {
        clientid: creditData.clientid,
        total: Number(creditData.total),
        date: creditData.date.format("YYYY-MM-DD"),
        addedfrom: userDetailsSession.staffid,
        clientnote: creditData.clientnote,
      };

      const response = await axios.post(
        `${API_BASE_CRM_URL}creditnotes/AddCreditNote`,
        payload,
      );

      if (response.data.Status || response.data.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Credit Added Successfully",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          setCreditDrawer(false);

          // Reset form
          setCreditData({
            clientid: null,
            total: "",
            date: dayjs(),
            clientnote: "",
          });

          // Refresh credit list
          fetchData(); // Your credit list API
        });
      }
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err,
      });
    }
  };

  const [expandedCard, setExpandedCard] = useState(null);

  const toggleCard = (id) => {
    setExpandedCard(expandedCard === id ? null : id);
  };

  const handleReload = () => {
    window.location.reload();
  };

  const handleExcelDownload = () => {
    if (creditsData.length === 0) {
      return; // Don't download if there is no data
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert your data to worksheet format
    const wsData = creditsData.map((item) => ({
      Payment: item.paymentsId,
      Invoice: `INV-2${item.invoiceId}`,
      "Payment Mode": item.paymentsModeName,
      "Transaction Id": item.transactionid,
      Customer: item.company_name,
      Amount: item.amount,
      Date: formatDate(item.date),
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "creditsData");

    // Save the workbook to a file
    XLSX.writeFile(wb, "creditsData.xlsx");
  };

  const handlePDFDownload = () => {
    const doc = new jsPDF();

    // Set properties for PDF
    doc.setProperties({
      title: "Leads Data",
      author: "Your Name",
      creator: "Your Application",
    });

    // Add data to PDF
    const tableData = []; // Your data array here

    // Add a header row
    const headers = [
      "Payment",
      "Invoice",
      "Payment Mode",
      "Transaction Id",
      "Customer",
      "Amount",
      "Date",
    ];
    tableData.push(headers);

    // Add rows
    creditsData.forEach((item) => {
      const row = [];
      row.push(
        item.paymentsId,
        `INV-2${item.invoiceId}`,
        item.paymentsModeName,
        item.transactionid,
        item.company_name,
        item.amount,
        formatDate(item.date),
      );
      tableData.push(row);
    });

    // Generate table
    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    // Save the PDF
    doc.save("creditsData.pdf");
  };
  return (
    <Base>
      <div className="">
        <div className="d-flex justify-content-between ">
          <div className="page-title">
            <h4>Credits</h4>
            <h6>Manage your Credits here</h6>
          </div>
          <div>
            <ul className="d-inline-flex list-unstyled gap-1 mb-0 justify-content-end">
              <li className="">
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="PDF"
                  onClick={handlePDFDownload}
                  className="btn btn-light btn-sm px-0"
                >
                  {/* <img src="assets/img/icons/pdf.svg" alt="PDF" /> */}
                  <i
                    className="fa-solid fa-file-pdf fa-2xl"
                    style={{ color: "#ff0000" }}
                  ></i>
                </a>
              </li>
              <li className="">
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Excel"
                  onClick={handleExcelDownload}
                  className="btn btn-light btn-sm "
                >
                  {/* <img src="assets/img/icons/excel.svg" alt="Excel" /> */}
                  <i
                    className="fa-solid fa-file-excel fa-2xl"
                    style={{ color: "#217346" }}
                  ></i>
                </a>
              </li>
              <li>
                <Link
                  // to="/addcredit"
                  className="btn btn btn-sm"
                  style={{ backgroundColor: "#1B2850" }}
                  onClick={() => setCreditDrawer(true)}
                >
                  <i
                    className="fa-solid fa-plus"
                    style={{ color: "white" }}
                  ></i>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-12 my-2">
          <div className="input-group">
            <input
              type="text"
              name="search"
              placeholder="Search..."
              className="form-control"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span className="input-group-text bg-primary" id="basic-addon1">
              <i className="fa-solid fa-magnifying-glass"></i>
            </span>
          </div>
        </div>
      </div>

      <div className="row g-2 mb-4">
        {loading ? (
          <div className="col-12 text-center">
            <div className="containers m-auto">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          </div>
        ) : (
          currentItems &&
          currentItems.map((item, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-4 p-0">
              <div className="card mb-0 rounded-4">
                <div className="card-body">
                  {/* Header */}
                  <div className="d-flex justify-content-between align-items-start mb-1">
                    {/* Left Side */}
                    <div className="d-flex align-items-center gap-1">
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          width: "35px",
                          height: "35px",
                          borderRadius: "50%",
                          backgroundColor: "#1B2850",
                          color: "#fff",
                        }}
                      >
                        <i className="fa-solid fa-money-check-dollar fs-5"></i>
                      </div>

                      <Link
                        to={`/view-payment/${item.id}`}
                        className="text-decoration-none"
                      >
                        <div className="d-flex gap-4">
                          <h5
                            className="mb-1 fw-bold"
                            style={{ color: "#1B2850" }}
                          >
                            {/* {item.prefix}
                            {item.number} */}
                            {item?.credit_note_number}
                          </h5>

                          <small
                            className={`badge   ${
                              item.status_id === 1
                                ? "bg-soft-success"
                                : item.status_id === 2
                                  ? "bg-warning text-dark"
                                  : item.status_id === 3
                                    ? "bg-danger"
                                    : "bg-secondary"
                            }`}
                          >
                            {item.status_id === 1
                              ? "open"
                              : item.status_id === 2
                                ? "Pending"
                                : item.status_id === 3
                                  ? "Cancelled"
                                  : "Unknown"}
                          </small>
                        </div>
                      </Link>
                    </div>

                    {/* Right Side */}
                    <div className="d-flex align-items-center gap-4">
                      <div className="text-end">
                        <div
                          className="fw-bold"
                          style={{
                            color: "#198754",
                            fontSize: "1.3rem",
                          }}
                        >
                          <i className="fa-solid fa-indian-rupee-sign me-1"></i>
                          {Number(item.amount || 0).toLocaleString("en-IN")}
                        </div>
                      </div>

                      {/* Dropdown */}
                      <div className="dropdown">
                        <a
                          className="text-dark"
                          href="/#"
                          onClick={(e) => e.preventDefault()}
                          data-bs-toggle="dropdown"
                        >
                          <i className="fa fa-ellipsis-v fs-5"></i>
                        </a>

                        <div className="dropdown-menu dropdown-menu-end">
                          {/* View Note */}
                          <button
                            type="button"
                            className="dropdown-item"
                            onClick={() => toggleCard(item.id)}
                          >
                            <i
                              className={`fa-solid ${
                                expandedCard === item.id
                                  ? "fa-chevron-up"
                                  : "fa-chevron-down"
                              } me-2`}
                            ></i>

                            {expandedCard === item.id
                              ? "Hide Note"
                              : "View Note"}
                          </button>

                          {/* Edit */}
                          {/* <Link to="" className="dropdown-item">
                            <i className="fa-regular fa-pen-to-square text-info me-2"></i>
                            Edit
                          </Link> */}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row g-1">
                    <div className="col-4">
                      <div className="d-flex align-items-center">
                        <i
                          className="fa-solid fa-user me-2"
                          style={{ color: "#1B2850" }}
                        ></i>
                        <span title={item?.cutomer_name}>
                          {item?.cutomer_name?.length > 12
                            ? item?.cutomer_name.substring(0, 12) + "..."
                            : item?.cutomer_name}
                        </span>
                      </div>
                    </div>

                    <div className="col-4">
                      <div className="d-flex align-items-center">
                        <i
                          className="fa-solid fa-calendar-days me-2"
                          style={{ color: "#1B2850" }}
                        ></i>
                        <span>{formatDate(item.date)}</span>
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="d-flex align-items-center">
                        <i
                          className="fa-solid fa-user-plus me-2"
                          style={{ color: "#1B2850" }}
                        ></i>
                        <span title={item.AddedByName}>
                          {item.AddedByName?.length > 20
                            ? item.AddedByName.substring(0, 20) + "..."
                            : item.AddedByName}
                        </span>
                      </div>
                    </div>

                    {expandedCard === item.id && (
                      <div className="">
                        <p
                          className="mb-0"
                          style={{
                            color: "#555",
                            lineHeight: "1.7",
                          }}
                        >
                          <i
                            className="fa-solid fa-note-sticky me-2"
                            style={{
                              color: "#1B2850",
                            }}
                          ></i>{" "}
                          {item.clientnote || "No remarks available."}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))
        )}

        <div className="col-12">
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={filteredItems.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      </div>

      <Drawer
        title={
          <div className="d-flex align-items-center">
            <i
              className="fa-solid fa-credit-card me-2"
              style={{
                color: "#1B2850",
                fontSize: 20,
              }}
            ></i>

            <span
              style={{
                color: "#1B2850",
                fontWeight: 600,
              }}
            >
              Add Collection
            </span>
          </div>
        }
        placement="bottom"
        height="50vh"
        open={creditDrawer}
        onClose={() => setCreditDrawer(false)}
        closeIcon={false}
        extra={
          <div className="d-flex gap-2">
            {/* Close */}
            <div
              onClick={() => setCreditDrawer(false)}
              style={{
                width: "38px",
                height: "38px",
                background: "#fff",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                border: "1px solid #e5e7eb",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              }}
            >
              <i
                className="fa-solid fa-xmark"
                style={{
                  color: "#dc3545",
                  fontSize: "16px",
                }}
              />
            </div>

            {/* Save */}
            <div
              onClick={handleAddCredit}
              style={{
                width: "38px",
                height: "38px",
                background: "#fff",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                border: "1px solid #e5e7eb",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              }}
            >
              <i
                className={`fa-solid ${
                  loading ? "fa-spinner fa-spin" : "fa-check"
                }`}
                style={{
                  color: "#198754",
                  fontSize: "16px",
                }}
              />
            </div>
          </div>
        }
      >
        <div className="row g-3">
          <div className="col-md-6">
            <Select
              size="large"
              className="w-100"
              placeholder="Select Customer"
              showSearch
              optionFilterProp="label"
              value={creditData.clientid}
              onChange={(value) =>
                setCreditData((prev) => ({
                  ...prev,
                  clientid: value,
                }))
              }
              options={customers.map((item) => ({
                value: item.customerId,
                label: item.company,
              }))}
            />
          </div>

          <div className="col-md-6">
            <Input
              size="large"
              type="number"
              placeholder="Amount"
              prefix={
                <i
                  className="fa-solid fa-indian-rupee-sign"
                  style={{
                    color: "#1B2850",
                    fontSize: "14px",
                  }}
                ></i>
              }
              value={creditData.total}
              onChange={(e) =>
                setCreditData({
                  ...creditData,
                  total: e.target.value,
                })
              }
            />
          </div>

          <div className="col-md-6">
            <DatePicker
              className="w-100"
              size="large"
              placeholder="Select Date"
              suffixIcon={
                <CalendarOutlined
                  style={{
                    color: "#1B2850",
                  }}
                />
              }
              value={creditData.date}
              onChange={(date) =>
                setCreditData({
                  ...creditData,
                  date,
                })
              }
            />
          </div>
          <div className="col-md-12">
            <Input.TextArea
              rows={4}
              placeholder="📝 Remarks"
              value={creditData.clientnote}
              onChange={(e) =>
                setCreditData({
                  ...creditData,
                  clientnote: e.target.value,
                })
              }
            />
          </div>
        </div>
      </Drawer>
      <Footer />
    </Base>
  );
};

export default Credit;
